forestControllers.controller('topPanelController', function($scope, $state, $rootScope, User) {

    $scope.logout = function(){
        User.logout().success(function(data){
            if(data['msg'] === 'Ok'){
                $rootScope.authed = false;
                $state.go('login');
            }
        });
    };

    $scope.toState = function(state){
        $state.go(state);
    };

    $scope.toAdmin = function(){
        $state.go('admin');
    };

    //This veriable will help us to show right controls depening on current state
    $scope.showUser = false;

    $scope.showBack = false;

    $rootScope.$on('$viewContentLoaded', function(event, toState, toParams, fromState, fromParams){
        $scope.showUser = $state.$current.name !== 'login';

        $scope.showBack = $state.$current.name !== 'welcome' && $state.$current.name !== 'login';
    });

    $rootScope.$on('$stateChangeSuccess',
        function(event, toState, toParams, fromState, fromParams){

            $scope.showUser = toState.name !== 'login';

            $scope.showBack = toState.name === 'app';
        });
});